"use client";

import "@soprisapps/schoolblocks/src/scss/_error.scss";
import "@soprisapps/schoolblocks/src/scss/_reset.scss";
import "@fortawesome/fontawesome-free/css/all.css";
import ErrorPage from "@soprisapps/components/pages/ErrorPage";

export default function NotFound() {
  return <ErrorPage />;
}
